import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    userLocation: null,
  },
  mutations: {
    updateUser: (state, user) => {
      state.user = user;
    },
    updateUserLocation: (state, location) => {
      state.userLocation = location;
    },
  },
  actions: {
    setUser: (context, user) => {
      context.commit('updateUser', user);
    },
    setUserLocation: (context, location) => {
      context.commit('updateUserLocation', location);
    },
  }
})